<template>
  <div class="folders-modal">
    <div class="modal-overlay" @click="$emit('close')"></div>
    <div class="modal-content">
      <div class="modal-header">
        <h3>Folders</h3>
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>
      
      <div class="folders-list">
        <div
          v-for="folder in folders"
          :key="folder.folder_id"
          class="folder-item"
          @click="selectFolder(folder)"
        >
          <div class="folder-icon">📁</div>
          <div class="folder-info">
            <h4>{{ folder.folder_name }}</h4>
            <p class="note-count">{{ folder.note_count }} {{ folder.note_count === 1 ? 'note' : 'notes' }}</p>
          </div>
          <div class="arrow-icon">›</div>
        </div>
        
        <div v-if="folders.length === 0" class="empty-folders">
          <div class="empty-icon">📂</div>
          <p>No folders yet</p>
          <p class="empty-subtitle">Create your first folder to organize notes</p>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="manage-btn" @click="$emit('manageFolders')">
          <i class="manage-icon">⚙️</i>
          Manage Folders
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FoldersModal',
  props: {
    folders: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close', 'selectFolder', 'manageFolders'],
  methods: {
    selectFolder(folder) {
      this.$emit('selectFolder', folder)
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.folders-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
  }
  
  .modal-content {
    position: relative;
    width: 90%;
    max-width: 400px;
    max-height: 70vh;
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    animation: modalSlideUp 0.3s ease-out;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e5e7eb;
    
    h3 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #111827;
    }
    
    .close-btn {
      width: 32px;
      height: 32px;
      border: none;
      border-radius: 16px;
      background: #f3f4f6;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 20px;
      color: #6b7280;
      
      &:active {
        background: #e5e7eb;
      }
    }
  }
  
  .folders-list {
    max-height: 300px;
    overflow-y: auto;
    padding: 8px 0;
    
    .folder-item {
      display: flex;
      align-items: center;
      padding: 16px 20px;
      cursor: pointer;
      transition: background 0.2s ease;
      
      &:active {
        background: #f9fafb;
      }
      
      .folder-icon {
        font-size: 24px;
        margin-right: 16px;
      }
      
      .folder-info {
        flex: 1;
        min-width: 0;
        
        h4 {
          margin: 0 0 4px 0;
          font-size: 16px;
          font-weight: 600;
          color: #111827;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .note-count {
          margin: 0;
          font-size: 14px;
          color: #6b7280;
        }
      }
      
      .arrow-icon {
        font-size: 16px;
        color: #9ca3af;
        margin-left: 8px;
      }
    }
    
    .empty-folders {
      text-align: center;
      padding: 40px 20px;
      
      .empty-icon {
        font-size: 48px;
        margin-bottom: 16px;
      }
      
      p {
        margin: 8px 0;
        color: #374151;
      }
      
      .empty-subtitle {
        font-size: 14px;
        color: #9ca3af;
      }
    }
  }
  
  .modal-footer {
    padding: 16px 20px;
    border-top: 1px solid #e5e7eb;
    background: #f9fafb;
    
    .manage-btn {
      width: 100%;
      padding: 12px;
      border: none;
      border-radius: 8px;
      background: #5065f6;
      color: white;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      
      &:active {
        background: #3d52cc;
      }
      
      .manage-icon {
        font-size: 16px;
      }
    }
  }
}

@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style> 